import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            fromDate: '',
            toDate: '',
            companyName: '',
            isDateError : null,
            vehicleMap: new Map(),
            vehicleReport: []
        }
    },
    computed: {
        filteredUsers() {
            return this.vehicleReport
        }
    },
    methods: {
        getReport: getReport,
        round: round,
        displayPrices: displayPrices,
        getFuel: getFuel,
        createEmptyMap: createEmptyMap,
        changedDateFrom: changedDateFrom,
        changedDateTo: changedDateTo,
        keymonitor: keymonitor,
        checkNull: checkNull,

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')

    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}



function changedDateFrom() {

}


function changedDateTo() {

}

function getReport() {
    var _self = this;
    var calendarTimestampFrom = Date.parse(_self.fromDate);
    var calendarTimestampTo = Date.parse(_self.toDate);
    if(isNaN(calendarTimestampFrom)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    if(isNaN(calendarTimestampTo)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });
    _self.isDateError = null;
    var date =  "?fromTimestamp=" + calendarTimestampFrom + "&toTimestamp="+calendarTimestampTo;
    AdminApiService.getSchedulesReport(date)
        .then((response) => {
            swal('Uspešno', 'Izveštaj uspešno kreiran', 'success');
            _self.vehicleMap = new Map()
            response.data.forEach(e => {
                if(e.schedules.length > 0){
                    e.schedules.forEach(schedule => {
                        var vehicleId = schedule.vehicle.id;
                        if(vehicleId != null){
                            var startKilometers = schedule.startKilometers;
                            var completionKilometers = schedule.completionKilometers;
                            if(startKilometers != null && completionKilometers){
                                const costsPerFuel = new Map(Object.entries(schedule.costsPerFuel));
                                const fuelPrices = new Map(Object.entries(schedule.fuelPrices));
                                var mapLitars = new Map()
                                var kilometersTraveled = completionKilometers - startKilometers;
                                costsPerFuel.forEach((value, key) => {
                                    var priceByType = fuelPrices.get(key)
                                    var litars = value / priceByType;
                                    mapLitars.set(key, litars)
                                })

                                var vehicleItem = {
                                    id: vehicleId,
                                    name: schedule.vehicle.name,
                                    plate: schedule.vehicle.registrationPlate,
                                    fuel: schedule.vehicle.fuel,
                                    kilometersTraveled: kilometersTraveled,
                                    liters: mapLitars,
                                    costsPerFuel: costsPerFuel,
                                }
                                if(!_self.vehicleMap.has(vehicleId)){
                                    _self.vehicleMap.set(vehicleId, [])
                                }
                                _self.vehicleMap.get(vehicleId).push(vehicleItem)
                            }
                        }
                    })
                }
            })
            _self.vehicleReport = []
            _self.vehicleMap.forEach((value, key) => {
                var v = {
                    id: '',
                    name: '',
                    plate: '',
                    fuel: '',
                    kilometersTraveled: 0,
                    liters: _self.createEmptyMap(),
                    costsPerFuel: _self.createEmptyMap(),
                    consumption: _self.createEmptyMap(),
                    // liters: { GASOLINE: 0, METHANE: 0, TNG: 0, DIESEL: 0, ELECTRIC: 0 },
                    // costsPerFuel: { GASOLINE: 0, METHANE: 0, TNG: 0, DIESEL: 0, ELECTRIC: 0 },
                }
                value.forEach(e => {
                    v.id = e.id
                    v.name = e.name
                    v.plate = e.plate
                    v.fuel = e.fuel
                    v.kilometersTraveled = v.kilometersTraveled + e.kilometersTraveled;
                    v.liters.forEach((value, key)=> {
                        var newValue = value + e.liters.get(key) != null ? e.liters.get(key) : 0;
                        v.liters.set(key, newValue)
                    })
                    v.costsPerFuel.forEach((value, key)=> {
                        var newValue = value + e.costsPerFuel.get(key) != null ? e.costsPerFuel.get(key) : 0;
                        v.costsPerFuel.set(key, newValue)
                    })

                })
                v.costsPerFuel.forEach((value, key)=> {
                    if(v.liters.has(key) && v.liters.get(key) != null){
                        if(v.liters.get(key) !== 0){
                            var newValue = v.kilometersTraveled / v.liters.get(key)
                            v.consumption.set(key, newValue)
                        }
                    }
                })
                _self.vehicleReport.push(v);
            })
        })
        .catch((error) => {
            console.error(error)
            swal('Greška', error.data.message, 'error')
        })
}

function createEmptyMap(){
    var map = new Map();
    map.set("GASOLINE", 0)
    map.set("METHANE", 0)
    map.set("TNG", 0)
    map.set("DIESEL", 0)
    map.set("ELECTRIC", 0)
    return map;
}

function displayPrices(map){
    var displayName = "";
    map.forEach((value, key)=>{
        if(value != null && value > 0){
            displayName += this.getFuel(key) +":"+value.toFixed(2) + "\n"
        }
    })
    return displayName;
}

function getFuel(fuel){
    switch (fuel) {
        case "GASOLINE": return "BENZIN";
        case "DIESEL": return "DIZEL";
        case "TNG": return "TNG";
        case "METHANE": return "METAN";
        case "ELECTRIC": return "ELEKTRIČNI";
        case "HYBRID": return "HIBRID";
        default: return ""
    }
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehicles();
    }
}


function checkNull(data) {
    if(data == null) return 0;
    return data;
}


function round(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100
}





// WEBPACK FOOTER //
// ./src/components/Report/VehicleReport.js